import Resource from '@/api/resources/Resource'

class GrossingVirtualShelvesService extends Resource {
    async getVirtualShelvesByLaboratoryId(labId, casId) {
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/virtualshelves`).then(response => response.data)
    }
}

export default new GrossingVirtualShelvesService()
